import { render, staticRenderFns } from "./platformUserManagement.vue?vue&type=template&id=3058659a&scoped=true&"
import script from "./platformUserManagement.vue?vue&type=script&lang=js&"
export * from "./platformUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./platformUserManagement.vue?vue&type=style&index=0&id=3058659a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3058659a",
  null
  
)

export default component.exports